<style lang="scss" scoped>
  .app-cloud-layout {
    height: 100%;

    > .el-header {
      padding: 0;

      &.immersive {
        height: 0 !important;
      }
    }

    > .el-main {
      background: #fff;
      overflow: visible;
      padding: 0;
    }

    &__main {
      min-height: 100%;
      padding-bottom: 64px;
      position: relative;
    }

    &__footer {
      bottom: 0;
      height: 64px;
      position: absolute;
      text-align: center;
      width: 100%;

      .iconfont {
        color: #000;
        font-size: 13px;
        opacity: 0;
      }

      .app-copy {
        color: #8c8c8c;
        font-size: 10px;
        margin-top: 16px;
        .icp {
          color: #8c8c8c;
          text-decoration: none;
          &:hover {
            color: #28e;
          }
        }
      }
    }
  }
</style>

<template>
    <el-container class="app-cloud-layout">
        <el-header :class="headerClass">
            <app-cloud-header></app-cloud-header>
        </el-header>
        <el-main sw-layout='fit'>
            <div class="app-cloud-layout__main">
                <router-view></router-view>
                <div class="app-cloud-layout__footer" ref="footer">
                    <!-- <i class="iconfont icon-geely_svg"></i> -->
                    <i class="iconfont icon-geely_svg"></i>
                    <p class="app-copy">
                      {{ $t('home.copyright', { year: (new Date()).getFullYear() }) }}
                      <a class="icp" href="http://www.beian.miit.gov.cn" target="_blank">{{ $t('home.icp') }}</a>
                    </p>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import store from './store';
import appCloudHeader from '@/views/app-cloud/header/header.vue';

export default {
  name: 'appCloudLayout',
  components: {
    appCloudHeader,
  },

  computed: {
    headerClass() {
      return this.$store.state.appCloudLayoutStore.headerClass;
    },
    // copyright() {
    //   return `© ${(new Date()).getFullYear()} 浙江吉利控股集团 / 浙ICP备11045738号-8`;
    // },
  },

  beforeCreate() {
    if (!this.$store.state.appCloudLayoutStore) this.$store.registerModule('appCloudLayoutStore', store);
  },
};
</script>
